import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import { handleApiError } from '@/utils/apiErrorHandler';
import { clearError } from './errorSlice';

export interface DashboardDates {
  annualPremiumNotificationsSent: string;
  effectiveDate: string;
  reconDueDatePriorToEffectiveDate: string;
  reconSubmissionEndDate: string;
}

export const fetchDashboardDates = createAsyncThunk(
  'dashboard/fetchDashboardDates',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      dispatch(clearError());
      const response = await axios.get('/papi/secure/dashboard');
      return response.data as DashboardDates;
    } catch (error) {
      handleApiError(error as AxiosError, 'dashboard', dispatch);
      return rejectWithValue(error instanceof Error ? error.message : 'Failed to fetch dashboard dates');
    }
  }
);

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    dates: {
      annualPremiumNotificationsSent: '',
      effectiveDate: '',
      reconDueDatePriorToEffectiveDate: '',
      reconSubmissionEndDate: '',
    } as DashboardDates,
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardDates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardDates.fulfilled, (state, action) => {
        state.loading = false;
        state.dates = action.payload;
      })
      .addCase(fetchDashboardDates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Unknown error';
      });
  },
});

export default dashboardSlice.reducer;
